import { Children, Fragment, type ReactNode } from "react"
import { Box } from "@mui/material"
import { faCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { makeStyles } from "tss-react/mui"

type StyleProps = Readonly<{
    gap: string
}>

type Props = Readonly<{
    children: ReactNode
    className?: string
    gap?: string
}>

const useStyles = makeStyles<StyleProps>()((theme, { gap }) => ({
    root: {
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap,
    },
    dot: {
        color: theme.palette.tailwind.slate[400],
        width: ".25rem",
        height: ".25rem",
    },
}))

export function StandardDotSeparator({ children, className, gap = ".5rem" }: Props) {
    const { classes, cx } = useStyles({ gap })
    const items = Children.toArray(children)

    return (
        <Box className={cx(classes.root, className)}>
            {items.map((child, index) => (
                <Fragment key={index}>
                    {index > 0 && <FontAwesomeIcon icon={faCircle} className={classes.dot} />}
                    {child}
                </Fragment>
            ))}
        </Box>
    )
}
